import MSlice from "../../helper/MSlice";

const assessmentSlice = new MSlice({ name: "assessment" });

export const assessmentActions = assessmentSlice.getActions();

export default assessmentSlice.getReducer();
